import { render, staticRenderFns } from "./BankAccountSwift.vue?vue&type=template&id=682c18b3&scoped=true"
import script from "./BankAccountSwift.vue?vue&type=script&lang=js"
export * from "./BankAccountSwift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682c18b3",
  null
  
)

export default component.exports